<!--
//================================================================================
// ID:BC003
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC003
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/02 | 富士通株式会社         | 新規作成
// 01.03.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.04.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<error-message />
		<section>
			<h2 class="contents__h2 title-style">利用者情報</h2>
			<table class="contents__table--stripe">
				<tbody>
					<tr class="contents__input--tr">
						<th class="contents__input--title">
							利用者<span class="contents__hissu">必須</span>
						</th>
						<td>
							<div class="contents__div--margin" id="contents--name__area">
								<div>
									氏：
									<text-input
										class="contents__input--text margin-Name"
										style="ime-mode: active"
										:modelValue="form.nmName1"
										:textType="TEXTINPUT_TYPE.FULL"
										:maxLength="15"
										:name="'利用者（氏）'"
										:groupId="'riyosyaInfo'"
										:placeholder="'例）東京'"
										:requireFlg="true"
										@update:modelValue="form.nmName1 = $event"
										ref="nmName1"
										:tabindex="1"
									/>
								</div>
								<div>
									名：
									<text-input
										class="contents__input--text margin-Name"
										style="ime-mode: active"
										:modelValue="form.nmName2"
										:textType="TEXTINPUT_TYPE.FULL"
										:name="'利用者（名）'"
										:maxLength="15"
										:groupId="'riyosyaInfo'"
										:placeholder="'例）太郎'"
										:requireFlg="true"
										@update:modelValue="form.nmName2 = $event"
										ref="nmName2"
										:tabindex="2"
									/>
								</div>
							</div>
							<div class="contents__div--margin">
								<itemerror-message :groupId="'riyosyaInfo'"/>
							</div>
						</td>
					</tr>
					<tr class="tr-color">
						<th class="contents__input--title">
							フリガナ<span class="contents__hissu">必須</span>
						</th>
						<td>
							<div class="contents__div--margin" id="contents--name__area">
								<div>
									氏：
									<text-input
										class="contents__input--text margin-Name"
										style="ime-mode: active"
										:modelValue="form.nmKana1"
										:textType="TEXTINPUT_TYPE.HALF_KANA"
										:name="'フリガナ（氏）'"
										:maxLength="30"
										:groupId="'huriganaInfo'"
										:placeholder="'例）ﾄｳｷｮｳ'"
										:requireFlg="true"
										@update:modelValue="form.nmKana1 = $event"
										ref="nmKana1"
										:tabindex="3"
									/>
								</div>
								<div>
									名：
									<text-input
										class="contents__input--text margin-Name"
										style="ime-mode: active"
										:modelValue="form.nmKana2"
										:textType="TEXTINPUT_TYPE.HALF_KANA"
										:name="'フリガナ（名）'"
										:maxLength="30"
										:groupId="'huriganaInfo'"
										:placeholder="'例）ﾀﾛｳ'"
										:requireFlg="true"
										@update:modelValue="form.nmKana2 = $event"
										ref="nmKana2"
										:tabindex="4"
									/>
								</div>
							</div>
							<div class="contents__div--margin">
								<itemerror-message :groupId="'huriganaInfo'"/>
								<div>
									<p class="contents__caution">
										※カタカナで入力してください。
									</p>
								</div>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr">
						<th class="contents__input--title">
							電話番号<span class="contents__hissu">必須</span>
						</th>
						<td>
							<div class="contents__div--margin">
								<number-input
									class="contents__input--text width-phone"
									:modelValue="form.idTel1"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:groupId="'phoneInfo'"
									:name="'電話番号（市外）'"
									:maxLength="5"
									:requireFlg="true"
									@update:modelValue="form.idTel1 = $event"
									ref="idTel1"
									:tabindex="5"
								/>
								-
								<number-input
									class="contents__input--text width-phone"
									:modelValue="form.idTel2"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:groupId="'phoneInfo'"
									:name="'電話番号（市内）'"
									:maxLength="4"
									:requireFlg="true"
									@update:modelValue="form.idTel2 = $event"
									ref="idTel2"
									:tabindex="6"
								/>
								-
								<number-input
									class="contents__input--text width-phone"
									:modelValue="form.idTel3"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:groupId="'phoneInfo'"
									:name="'電話番号（局番）'"
									:maxLength="4"
									:requireFlg="true"
									@update:modelValue="form.idTel3 = $event"
									ref="idTel3"
									:tabindex="7"
								/>
								<itemerror-message :groupId="'phoneInfo'"/>
							</div>
							<div class="contents__div--margin">
								<div>
									<p class="contents__caution">※数字で入力してください。</p>
								</div>
							</div>
						</td>
					</tr>
					<tr class="tr-color">
						<th class="contents__input--title" rowspan="3">
							メールアドレス<span class="contents__hissu">必須</span>
						</th>
						<td>
							<div class="contents__div--margin">
								<div>
									<text-input
										class="contents__input--text width-mail"
										:modelValue="form.idMailaddress"
										:textType="TEXTINPUT_TYPE.E_MAIL"
										:groupId="'mailInfo'"
										:name="'メールアドレス'"
										:maxLength="255"
										:placeholder="'例）someone@example.com'"
										:requireFlg="true"
										@update:modelValue="form.idMailaddress = $event"
										ref="idMailaddress"
										:tabindex="8"
									/>
								</div>
								<div class="div-padding">
									<p class="contents__caution">
										※メールアドレスを入力してください。
									</p>
								</div>
								<div>
									<text-input
										class="contents__input--text width-mail"
										:modelValue="form.txtEmail2"
										:textType="TEXTINPUT_TYPE.E_MAIL"
										:groupId="'mailInfo'"
										:name="'メールアドレス（確認用）'"
										:maxLength="255"
										:placeholder="'例）someone@example.com'"
										:requireFlg="true"
										@update:modelValue="form.txtEmail2 = $event"
										ref="txtEmail2"
										:tabindex="9"
									/>
									<itemerror-message :groupId="'mailInfo'"/>
								</div>
								<div>
									<p class="contents__caution">
										※確認のため、もう一度入力してください。
									</p>
								</div>
								<div class="div-margintop">
									<p class="contents__caution">
										（コピー・貼り付けはしないでください。）
									</p>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<br />
			<div class="div-margin">
				<div class="div_row contents__caution--multiple">
					<label class="contents__caution contents__caution--multiple contents__caution--font_warn_nonbold">
						{{ disp.riyokiyakuTyuiItem[0] }}
					</label>
					<br>
					<label class="contents__caution contents__caution--multiple contents__caution--font_warn_nonbold">
						{{ disp.riyokiyakuTyuiItem[1] }}
						<a :href="disp.riyokiyakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1" @click="confirmKiyaku">{{ disp.riyokiyakuLkMessage }}</a>
					</label>
				</div>
			</div>
			<br />
			<div class="cond__checkbox riyokiyaku-title">
				<check-box
					id="check"
					:modelValue="form.riyokiyaku"
					:name="'利用規約に同意します。'"
					:listItems="disp.riyokiyakuList"
					:disabledFlg="disp.riyokiyakuCheck"
					@update:modelValue="form.riyokiyaku = $event"
					tabindex="10"
					ref="riyokiyaku"
				/>
			</div>
			<br />
			<div align="center">
				<div id="mailmsg">
					<label id="label2">
						【注意】<label class="contents__div--MOBILE"><br /></label
						>入力したメールアドレスは、本登録完了後のログイン時に使用するユーザIDとなります。
					</label>
				</div>
			</div>
			<br />
			<div class="contents__div--center">
				<input
					type="submit"
					value="仮登録する"
					id="btn"
					class="contents__btn--confirm btn-marginright"
					@click="sinsei"
					tabindex="11"
					:disabled="disp.kariBtn"
				/>
				<input
					type="button"
					value="戻る"
					@click="back"
					class="contents__btn--cancel routerLink-kasen"
					tabindex="12"
				/>
			</div>
			<br />
			<div align="center" class="margin__bottom-page">
				<p id="mailmsg">
					<label class="label-lineheight">
						仮登録を受け付け後、本登録するためのURLをメールアドレス宛に送信いたします。<br />本登録は２４時間以内に行ってください。
					</label>
				</p>
			</div>
			<br />
		</section>
	</div>
	<!--◆編集エリア END◆-->
</template>

<script>
import ErrorMessage from "@/components/ErrorMessage.vue";
import TextInput from "@/components/TextInput.vue";
import NumberInput from "@/components/NumberInput.vue";
import CheckBox from "@/components/CheckBox.vue";
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';

import { co_post } from "@/common/ajaxUtility.js";
import { co_completedDialog } from "@/common/dialogUtility.js";
import { co_getMessage } from "@/common/messageUtility.js";
import { co_isEmpty } from '@/common/checkUtility.js';
import { co_isOperation } from '@/common/browserUtility.js'; 
import { co_toTrans, co_clearParam} from '@/common/screenUtility.js';

import {
	NUMBERINPUT_TYPE,
	DIALOG_BUTTON_LIST_KEY,
	TEXTINPUT_TYPE,
} from "@/const/const.js";
import {
	STORE_ERROR_CLEAR,
	STORE_ERROR_IS_ERRFLG,
	STORE_ERROR_SET_INPUT_ERR,
	STORE_VIEW_GET_PARAMS
} from "@/const/store.js";
import { PATH_BC003_MAILDATA, PATH_BC003_INSERTDATA, PATH_BC003_CHECKMAIL, API_CAUTION_ITEMS } from "@/const/route.js";

export default {
	name: "BC003",
	components: {
		"error-message": ErrorMessage,
		"text-input": TextInput,
		"number-input": NumberInput,
		'itemerror-message': ItemErrorMessage,
		"check-box": CheckBox,
	},
	data: function () {
		return {
			form: {
				nmName1: "", 			// 利用者氏名（氏）
				nmName2: "", 			// 利用者氏名（名）
				nmKana1: "", 			// フリガナ（氏）
				nmKana2: "", 			// フリガナ（名）
				idTel1: "", 			// 電話番号（市外）
				idTel2: "", 			// 電話番号（市内）
				idTel3: "", 			// 電話番号（局番）
				idMailaddress: "", 		// メールアドレス
				txtEmail2: "", 			// メールアドレス（確認用）
				riyokiyaku: '',			// 利用規約に同意します。
			},
			disp: {
				riyokiyakuList: [], 		// 利用規約同意
				riyokiyakuCheck: true,		// 利用規約同意チェックボックス
				kariBtn: true, 				// 仮登録ボタン
				riyokiyakuTyuiItem: [],		// 利用規約注意文
				riyokiyakuLkMessage: '',	// 利用規約注意文（リンクメッセージ）
				riyokiyakuLink: ''			// 外部リンクURL
			},
			callViewId: '',					// 遷移先画面ID
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE,
		};
	},
	mounted: async function () {
		await this.$nextTick();

		// フォーカス設定
		this.$refs.nmName1.focus();
	},
	created: async function () {

		// ブラウザチェック
		if (!await co_isOperation()) {
			co_toTrans('BrowserError');
		}

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// 遷移元画面からのパラメータを取得
		let params = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC003');
		if (typeof params != 'undefined') {
			this.callViewId = params.callViewId;
		}

		// 画面間パラメータを削除
		co_clearParam('BC003');

		// キーワード項目設定
		this.disp.riyokiyakuList = [{ idCd: '1', nmCd: '利用規約に同意します。' }];

		// 利用規約注意文生成
		this.createKiyakuTyuibun();
	},
	watch: {
		'form.riyokiyaku' : function() {
			if (this.form.riyokiyaku == '1') {
				this.disp.kariBtn = false;
			} else {
				this.disp.kariBtn = true;
			}
		}
	},
	methods: {
		sinsei: async function () {
			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 単項目チェック
			this.$refs.nmName1.validate();
			this.$refs.nmName2.validate();
			this.$refs.nmKana1.validate();
			this.$refs.nmKana2.validate();
			this.$refs.idTel1.validate();
			this.$refs.idTel2.validate();
			this.$refs.idTel3.validate();
			this.$refs.idMailaddress.validate();
			this.$refs.txtEmail2.validate();
			this.$refs.riyokiyaku.validate();

			// メールアドレスとメールアドレス（確認用）が同一ではない場合
			if (this.form.idMailaddress != this.form.txtEmail2) {
				this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
					id: "mailInfo",
					msg: co_getMessage("E0005"),
				});
				this.$refs.idMailaddress.setError();
				this.$refs.txtEmail2.setError();
				return;
			}

			// 入力チェックエラーが存在しない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {

				// メールアドレス形式チェック
				let checkResult = await co_post(PATH_BC003_CHECKMAIL, this.form);
				if (checkResult == '10') {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "mailInfo",
						msg: co_getMessage("E0004", "メールアドレス"),
					});
					this.$refs.idMailaddress.setError();
					this.$refs.idMailaddress.focus();
				} else if (checkResult == '12') {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "mailInfo",
						msg: co_getMessage("E0004", "メールアドレス"),
					});
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "mailInfo",
						msg: co_getMessage("E0004", "メールアドレス（確認用）"),
					});
					this.$refs.idMailaddress.setError();
					this.$refs.txtEmail2.setError();
					this.$refs.idMailaddress.focus();
				} else if (checkResult == '02') {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "mailInfo",
						msg: co_getMessage("E0004", "メールアドレス（確認用）"),
					});
					this.$refs.txtEmail2.setError();
					this.$refs.txtEmail2.focus();
				}

				if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
					// メールアドレス形式チェックでエラーとなった場合
					return;
				}

				// メールアドレスがすでに本登録されている場合
				let data = await co_post(PATH_BC003_MAILDATA, this.form);
				if (data === 1) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "mailInfo",
						msg: co_getMessage("E0010"),
					});
					this.$refs.idMailaddress.setError();
					this.$refs.txtEmail2.setError();
					return;
				}

				// 登録処理呼び出し
				await co_post(PATH_BC003_INSERTDATA, this.form);

				// 完了ダイアログ表示
				co_completedDialog(co_getMessage("I0001"), this.doSinsei);
				return;
			}
		},
		// ダイアログ「はい」ボタン押下時処理
		doSinsei: async function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				window.location.href = 'https://www.juutakuseisaku.metro.tokyo.lg.jp/toei_online/index.html'; 
				return;
			}
		},
		// 利用規約注意文生成
		createKiyakuTyuibun: async function () {
			let params = {tyuibunList: ["C0188"]};
			let val = await co_post( API_CAUTION_ITEMS, params );

			if ( val != null ) {
				for ( let i = 0; i < val.length; i++ ) {
					let sentenceList = [];		// メッセージリスト
					let message = [];			// 画面表示用メッセージ
					let lkMessage = '';			// 画面表示用リンクメッセージ
					let lkUrl = '';				// 外部リンクURL

					sentenceList = val[i].messageNaiyo.split(/\r\n|\n/);
					for ( let j = 0; j < sentenceList.length; j++ ) {
						if (sentenceList[j].indexOf('%A'+ (i)) >= 0) {
							let list = sentenceList[j].split('%A0S');
							message.push(list[0]);
							lkMessage = list[1].replace('%A0E', '');
						} else {
							message.push(sentenceList[j]);
						}
					}

					// URLリンク生成
					if (!co_isEmpty(val[i].lkUrl)) {
						let lkUrlList = val[i].lkUrl.split(/\r\n|\n/);
						for (let i = 0; i < lkUrlList.length; i++) {
							lkUrl = lkUrlList[i].split('：')[1];
						}
					}

					this.disp.riyokiyakuTyuiItem = message;
					this.disp.riyokiyakuLkMessage = lkMessage;
					this.disp.riyokiyakuLink = lkUrl;
				}
			}
		},
		// 規約確認
		confirmKiyaku: function () {
			// チェックボックスを活性にする
			this.disp.riyokiyakuCheck = false;
		},
		// 戻る
		back: function () {
			// 遷移先判定
			if(!co_isEmpty(this.callViewId)){
				// 呼出画面有り
				co_toTrans(this.callViewId);
			} else {
				// 呼出画面無し
				co_toTrans("BC001");
			}
		}
	},
};
</script>

<style scoped>
#mailmsg {
	display: inline-block;
	text-align: left;
}
#label2 {
	font-weight: bold;
	line-height: normal;
}
.title-style {
	margin-top: 1%;
	display: inline-block;
}
.tr-color {
	background-color: #f1f2f5;
}
.div-padding {
	padding-bottom: 10px;
}
.div-margintop {
	margin-top: -5px;
}
.btn-marginright {
	margin-right: 3%;
}
.routerLink-kasen {
	margin-left: 7%;
}
.label-lineheight {
	line-height: 1.5em;
}
input[type="submit"][disabled] {
	background-color: #FFD7A7;
	color: #5C5C5C;
	border-color: #FFD7A7;
	cursor: default;
}		 
input[type="submit"][disabled]:hover{
	opacity:1;
}
/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.contents__main {
		font-size: 16px;
	}
	.contents__hissu {
		right: 60%;
	}
	.contents__div--margin {
		margin-left: -60%;
	}
	.width-phone {
		text-align: left;
	}
	.div-margin {
		margin-left: 222px;
		font-size: 18px;
	}
	.riyokiyaku-title {
		margin-left: 206px;
	}
	.margin-Name {
		width: 70%;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.contents__hissu {
		margin: 2px 0 0 5px !important;
	}
	.p-lineheight {
		line-height: 1.4em;
	}
	.contents__table--stripe td,
	.contents__table--stripe th {
		line-height: 1.3em;
	}
	.width-phone {
		text-align: left;
	}
	.div-margin {
		margin-left: 5px;
		font-size: 20px;
	}
	.riyokiyaku-title {
		margin-left: -10px;
	}
	.margin-Name {
		margin-bottom: 10px;
	}
}
</style>